import { render, staticRenderFns } from "./BookCard.vue?vue&type=template&id=5f0f3df7"
import script from "./BookCard.vue?vue&type=script&lang=js"
export * from "./BookCard.vue?vue&type=script&lang=js"
import style0 from "./BookCard.vue?vue&type=style&index=0&id=5f0f3df7&prod&lang=css"
import style1 from "./BookCard.vue?vue&type=style&index=1&id=5f0f3df7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports